import { render, staticRenderFns } from "./DevicetypesUpdate.vue?vue&type=template&id=29b2465a&"
import script from "./DevicetypesUpdate.vue?vue&type=script&lang=js&"
export * from "./DevicetypesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports